import { ROUTES } from '../router';

export default {
  isLogged: state => state.user && state.user.id,
  isFiles: state => !state.loading && (state.route.name === 'Files' || state.route.name === ROUTES.BIN || state.route.name === ROUTES.BACKUP || state.route.name === 'Reg' || state.route.name === ROUTES.CLOUD || state.route.name === ROUTES.SECRET || state.route.name === ROUTES.MY_SHARED_DRIVES || state.route.name === ROUTES.SHARED_WITH_ME || state.route.name === 'Drive' || state.route.name === ROUTES.ARCHIVED),
  isBackup: state => state.route.name === ROUTES.BACKUP,
  isRegister: state => !state.loading && state.route.name === 'Reg',
  isTransfers: state => state.req.isTransfers,
  isListing: (state, getters) => getters.isFiles && state.req.isDir,
  isEditor: (state, getters) => getters.isFiles && (state.req.type === 'text' || state.req.type === 'textImmutable' || state.req.type === 'txt'),
  isSheets: (state, getters) => getters.isFiles && state.req.type === 'xls',
  isDocs: (state, getters) => getters.isFiles && state.req.type === 'doc',
  selectedCount: state => state.selected.length,
  isBin: state => !state.loading && (state.route.name === ROUTES.BIN),
  isFolder: state => !state.loading && (state.route.name === ROUTES.SHARED_FOLDER || state.route.name === ROUTES.SHARED_FILE),
  isShare: state => !state.loading && (state.route.name === 'Share'),
  isSettings: state => !state.loading && (state.route.name === ROUTES.SETTINGS || state.route.name === ROUTES.INVOICING || state.route.name === 'Invoicing Plans' || state.route.name === ROUTES.INFO || state.route.name === ROUTES.ACCOUNT),
  isCloud: state => !state.loading && (state.route.name === ROUTES.CLOUD || state.route.name === ROUTES.SECRET),
  isSharedDrive: state => !state.loading && (state.route.name === ROUTES.MY_SHARED_DRIVES || state.route.name === ROUTES.SHARED_WITH_ME || state.route.name === ROUTES.ARCHIVED || state.route.name === ROUTES.DRIVE),
  isMaxStorage: state => state.accountInfo.ustorage > state.accountInfo.tstorage && state.accountInfo.amount === 0,
  accountUsage(state) {
    if (!state.accountInfo) {
      return null;
    }
    if (state.accountInfo.tstorage <= state.accountInfo.ustorage) {
      return 100 + '%';
    }
    return ((state.accountInfo.ustorage/state.accountInfo.tstorage)*100).toFixed(2) + '%';
  },
  isAdmin: (state) => state.accountInfo.email === state.userInfo.email,
  hasPaymentMethod: (state) => state.invoicingInfo.credit !== 0,
  hasCloudFeature: (state) => state.accountInfo.features & Module.FeatureType.FEATURE_CLOUD.value,
  hasBackupFeature: (state) => state.accountInfo.features & Module.FeatureType.FEATURE_BACKUP.value,
  hasBmailFeature: (state) => state.accountInfo.features & Module.FeatureType.FEATURE_BMAIL.value,
  hasSecretsFeature: (state) => state.accountInfo.features & Module.FeatureType.FEATURE_SECRETS.value,
  isFreePlan: (state) => state.invoicingInfo.subscription.amount === 0,
};
